// src/components/ContactInfoBoxes.js

import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const ContactInfoBoxes = () => {
  return (
    <div className="flex flex-col md:flex-row justify-center items-center md:items-start gap-8">
      
      {/* Telephone Box */}
      <div className="flex flex-col items-center text-center p-6 border border-gray-300 rounded-2xl w-full md:w-1/3">
       <FaPhoneAlt size={40} className="mb-4 text-gray-900" />
       <h2 className="font-bold text-lg md:text-base mb-2">Phone</h2>
       <p className="text-base md:text-sm">+90 850 346 91 60</p>
      </div>

      {/* Address Box */}
      <div className="flex flex-col items-center text-center p-6 border border-gray-300 rounded-2xl w-full md:w-1/3">
       <FaMapMarkerAlt size={40} className="mb-4 text-gray-900" />
       <h2 className="font-bold text-lg md:text-base mb-2">Address</h2>
       <p className="text-base md:text-sm">
         Maslak Mah. AOS 55. Sok. 42 Maslak B Blok Sitesi No:4 İç Kapı: 542 Sarıyer / Istanbul
       </p>
      </div>

      {/* E-mail Box */}
      <div className="flex flex-col items-center text-center p-6 border border-gray-300 rounded-2xl w-full md:w-1/3">
       <FaEnvelope size={40} className="mb-4 text-gray-900" />
       <h2 className="font-bold text-lg md:text-base mb-2">Email</h2>
       <p className="text-base md:text-sm">info@match-medic.com</p>
      </div>

    </div>
  );
};

export default ContactInfoBoxes;
